/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Machine_Id_LabelInputs */



/**
* | output |
* | --- |
* | "Machine ID" |
*
* @param {Login_Offline_Machine_Id_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_machine_id_label = /** @type {((inputs?: Login_Offline_Machine_Id_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Machine_Id_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ID de Machine")
	if (locale === "de") return /** @type {LocalizedString} */ ("Maschinen-ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("ID macchina")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Идентификатор машины")
	if (locale === "es") return /** @type {LocalizedString} */ ("Identificación de la máquina")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("机器 ID")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マシンID")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मशीन आईडी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("ID da máquina")
	return /** @type {LocalizedString} */ ("Machine ID")
});